import React from "react"
import {
  Box, Text, BoxProps, TextProps,
} from "@chakra-ui/react"

type Variant = "default" | "ticket"

type Props = {
  name: string
  email: string
  variant?: Variant
}

type StyleConfig = {
  container: BoxProps
  name: TextProps
  email: TextProps
}

const GuestNameAndEmail = ({ name, email, variant = "default" }: Props) => {
  const styles: Record<Variant, StyleConfig> = {
    default: {
      container: {
        mb: 4,
      },
      name: {
        fontSize: "2xl",
        fontWeight: "semibold",
        mb: -1,
      },
      email: {
        fontSize: "lg",
      },
    },
    ticket: {
      container: {
        textAlign: "center",
      },
      name: {
        fontSize: "xl",
        fontWeight: "bold",
        color: "gray.800",
        noOfLines: 1,
      },
      email: {
        fontSize: "sm",
        color: "gray.600",
        noOfLines: 1,
      },
    },
  }

  const currentStyle = styles[variant]

  return (
    <Box {...currentStyle.container}>
      <Text {...currentStyle.name}>{name}</Text>
      {email && <Text {...currentStyle.email}>{email}</Text>}
    </Box>
  )
}

export default GuestNameAndEmail
